import salesAnalysis from './projects-img/salesAnalysis.png';
import hrAnalysis from './projects-img/hrAnalysis.jpg';
import helthCare from './projects-img/helthCare.png';
import Electric from './projects-img/Electric.jpg';
import realestate from './projects-img/realestate.png';
import customer_churn from './projects-img/customer_churn.png';
const projects = [
	{
		id: 2,
		title: 'Project 2',
		description: 'This is project 2',
		imageUrl: realestate,
		demoUrl: 'https://dazzling-blancmange-e76d48.netlify.app/',
		githubUrl: 'https://github.com/EsraaMhamed1/Real-Estate-Data-Analysis',
	},
	{
		id: 1,
		title: 'Customer Churn Analysis ',
		description: 'This is project 1',
		imageUrl: customer_churn,
		demoUrl: 'https://esraamhamed1.github.io/omnifood-app/',
		githubUrl:
			'https://github.com/EsraaMhamed1/Power-BI-Data-Analysis-Dashboards-',
	},

	{
		id: 4,
		title: 'Project 2',
		description: 'This is project 1',
		imageUrl: salesAnalysis,
		demoUrl:
			'https://66d169e907a0751ce4c7fd8f--glittering-pothos-419352.netlify.app/',
		githubUrl: 'https://github.com/EsraaMhamed1/Excel-professional-Dashboard',
	},
	{
		id: 3,
		imageUrl: helthCare,
		demoUrl: 'https://esraa.netlify.app/',
		githubUrl: 'https://github.com/EsraaMhamed1/HealthCare-Dashboard-Power-BI-',
	},

	{
		id: 5,
		title: 'Project 4',
		description: 'This is project 1',
		imageUrl: hrAnalysis,
		demoUrl: 'https://illustrious-blancmange-81ef63.netlify.app/',
		githubUrl: 'https://github.com/EsraaMhamed1/HR-Dashboard-USing-Power-BI-',
	},

	{
		id: 6,
		title: 'Project 5',
		description: 'This is project 1',
		imageUrl: Electric,
		demoUrl: 'https://regal-sable-b8ee88.netlify.app/',
		githubUrl: 'https://github.com/EsraaMhamed1/Electric-vhicles/tree/main',
	},
];

export default projects;
